import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'taxihandgo-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/button/button.component.ts